import Entity from "../entity";

export class UpdateOrderInRefundType extends Entity<number> {
    personNames: string;
    personCount: number;
    linkMan: string;
    price: number;
  }
  
export default class Order extends Entity<number> {
  orderNum: string = "";
  orderType: number = 0;
  orderState: number = 0;
  productId: number = 0;
  name: string = "";
  teeTime: Date = new Date();
  personCount: number = 1;
  personNames: string = "";
  price: number = 0;
  reduction: number | any = 0;
  couponReduction: number = 0;
  amount: number = 0;
  payMoney: number = 0;
  outTradeNo: string = "";
  weixinOpenId: string = "";
  prepayId: string = "";
  prepayCodeUrl: string = "";
  addIp: string = "";
  payParam: string = "";
  payMethod: string = "";
  linkMan: string = "";
  phoneNumber: string = "";
  address: string = "";
  remark: string = "";
  creationTime: Date;
  vipReduction: any | number = 0;
  cashback: any;
  service: string = "";
  weixinPay: number | any = null;
  flatOffer: any = null;
}

